import Phaser from 'phaser'
import Config from '../launch/config'

export default class ArcTimer {
    constructor(props) {
        const {
            alpha,
            color,
            duration,
            hidden,
            lineWidth,
            radius,
            reverse,
            x,
            y,
        } = props
        const chance = Config.chance

        this.alpha = alpha || 1
        this.color = color
        this.id = chance.guid()
        this.duration = duration
        this.endAngle = 360
        this.graphics = Config.scene.add.graphics()
        this.lineWidth = lineWidth || 3
        this.radius = radius
        this.reverse = reverse
        this.startAngle = -90
        this.x = x
        this.y = y
        this.graphics.setVisible(!hidden)

        Config.timers[this.id] = this

        this.promise = new Promise((resolve, reject) => {
            this.reject = reject
            // https://labs.phaser.io/view.html?src=src/time\timer%20event.js
            this.timedEvent = Config.scene.time.delayedCall(
                this.duration,
                () => {
                    this.graphics.destroy()
                    delete Config.timers[this.id]
                    resolve(this)
                },
                [],
                this
            )
        })
    }

    remove() {
        this.reject()
        this.graphics.destroy()
        delete Config.timers[this.id]
    }

    update(time, delta) {
        if (!Config.timers[this.id]) {
            return
        }

        if (Config.isGameOver) {
            this.remove()
            return
        }

        const progress = this.timedEvent.getProgress()
        let percentage = (100 * progress) / 1

        if (this.reverse) {
            percentage = 100 - percentage
        }

        this.endAngle = (percentage / 100) * 360 + this.startAngle

        this.graphics.clear()
        this.graphics.lineStyle(this.lineWidth, `0x${this.color}`, this.alpha)

        // Without this the arc will appear closed when stroked
        this.graphics.beginPath()

        // arc (x, y, radius, startAngle, endAngle, anticlockwise)
        // https://photonstorm.github.io/phaser3-docs/Phaser.GameObjects.Arc.html
        this.graphics.arc(
            this.x,
            this.y,
            this.radius,
            Phaser.Math.DegToRad(this.startAngle),
            Phaser.Math.DegToRad(this.endAngle),
            false
        )

        this.graphics.strokePath()
    }
}
